import { render, staticRenderFns } from "./PriceRanges.vue?vue&type=template&id=7b3972b8&"
import script from "./PriceRanges.vue?vue&type=script&lang=js&"
export * from "./PriceRanges.vue?vue&type=script&lang=js&"
import style0 from "./PriceRanges.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports